import { css } from 'lit';

import { sharedUiStyles } from '../../styles/shared-ui.styles';

export const settingsSharedStyles = css`
  ${sharedUiStyles}

  :host {
    --settings-surface: var(--kv-surface);
    --settings-surface-muted: var(--kv-surface-muted);
    --settings-surface-hover: var(--kv-surface-hover);
    --settings-border: var(--kv-border);
    --settings-accent: var(--kv-accent);
    --settings-accent-bg: var(--kv-accent-bg);
    --settings-shadow: var(--kv-shadow);
    --settings-input-bg: var(--kv-surface);
    --settings-control-bg: var(--kv-control-bg);
    --settings-control-hover: var(--kv-control-hover);
    --settings-control-active: var(--kv-control-active);
    --settings-control-border: var(--kv-control-border);
    --settings-danger: var(--kv-danger);
    --settings-danger-bg: var(--kv-danger-bg);
    --settings-danger-hover: var(--kv-danger-hover);
    --settings-danger-active: var(--kv-danger-active);
    --settings-danger-border: var(--kv-danger-border);
    display: block;
    color: var(--color-app-text);
  }

  .settings-section {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .settings-section + .settings-section {
    margin-top: 20px;
  }

  .settings-header {
    max-width: 780px;
  }

  .settings-title-row {
    align-items: center;
    display: flex;
    gap: 10px;
    min-width: 0;
  }

  .settings-title-icon {
    align-items: center;
    color: var(--settings-accent);
    display: inline-flex;
    flex: 0 0 auto;
    height: 22px;
    justify-content: center;
    width: 22px;
  }

  .settings-title {
    color: var(--color-app-text);
    font-size: 21px;
    font-weight: 700;
    line-height: 1.2;
    margin: 0;
  }

  .settings-description {
    color: var(--color-app-text-secondary);
    font-size: 13px;
    line-height: 1.45;
    margin: 7px 0 0;
  }

  .settings-panel {
    background: transparent;
    border: 0;
    border-top: 1px solid var(--settings-border);
    border-radius: 0;
    box-shadow: none;
    box-sizing: border-box;
    padding: 16px 0 0;
  }

  .settings-panel-header {
    align-items: flex-start;
    display: flex;
    gap: 14px;
    justify-content: space-between;
    margin-bottom: 14px;
  }

  .settings-panel-title {
    color: var(--color-app-text);
    font-size: 14px;
    font-weight: 700;
    line-height: 1.25;
    margin: 0;
  }

  .settings-panel-description {
    color: var(--color-app-text-secondary);
    font-size: 12px;
    line-height: 1.4;
    margin: 4px 0 0;
  }

  .settings-card-grid {
    display: grid;
    gap: 12px;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  }

  .settings-card {
    background: var(--settings-surface);
    border: 1px solid var(--settings-border);
    border-radius: 8px;
    box-shadow: var(--kv-card-shadow);
    box-sizing: border-box;
    min-width: 0;
    padding: 14px;
    transition:
      background 0.14s ease,
      border-color 0.14s ease,
      box-shadow 0.14s ease;
  }

  .settings-card:hover {
    background: var(--settings-surface-hover);
    border-color: var(--kv-accent-border-subtle);
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.07);
  }

  .settings-action-card {
    align-items: stretch;
    appearance: none;
    background: var(--settings-surface);
    border: 1px dashed var(--kv-accent-border);
    border-radius: var(--kv-radius-panel);
    box-sizing: border-box;
    color: var(--color-app-text);
    cursor: pointer;
    display: flex;
    font: inherit;
    min-height: 112px;
    padding: 16px;
    text-align: left;
    transition:
      background-color 0.14s ease,
      border-color 0.14s ease,
      box-shadow 0.14s ease,
      transform 0.14s ease;
    width: 100%;
  }

  .settings-action-card:hover {
    background: var(--settings-accent-bg);
    border-color: var(--settings-accent);
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.07);
    transform: translateY(-1px);
  }

  .settings-action-card:focus-visible {
    outline: 2px solid var(--settings-accent);
    outline-offset: 2px;
  }

  .settings-action-content {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    gap: 9px;
    justify-content: center;
    min-width: 0;
    width: 100%;
  }

  .settings-action-icon {
    align-items: center;
    color: var(--settings-accent);
    display: inline-flex;
    height: 24px;
    justify-content: center;
    width: 24px;
  }

  .settings-action-title {
    color: var(--color-app-text);
    font-size: 14px;
    font-weight: 700;
    line-height: 1.25;
  }

  .settings-action-description {
    color: var(--color-app-text-secondary);
    font-size: 12px;
    line-height: 1.4;
  }

  .settings-detail-list {
    border-top: 1px solid var(--settings-border);
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-top: 12px;
    padding-top: 12px;
  }

  .settings-detail-row {
    align-items: center;
    display: flex;
    gap: 12px;
    justify-content: space-between;
    min-width: 0;
  }

  .settings-detail-label {
    color: var(--color-app-text-secondary);
    font-size: 12px;
  }

  .settings-detail-value {
    color: var(--color-app-text);
    font-size: 12px;
    font-weight: 650;
    min-width: 0;
    overflow: hidden;
    text-align: right;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .settings-chip {
    align-items: center;
    border-radius: var(--kv-radius-chip);
    display: inline-flex;
    font-size: 11px;
    font-weight: 700;
    gap: 5px;
    line-height: 1.2;
    padding: 4px 9px;
    white-space: nowrap;
  }

  .settings-chip.success {
    background: var(--color-success-bg);
    color: var(--color-success-text);
  }

  .settings-chip.error {
    background: var(--color-error-bg);
    color: var(--color-error-text);
  }

  .settings-chip.warning {
    background: var(--kv-warning-bg);
    color: var(--kv-warning-text);
  }

  .settings-chip.neutral {
    background: var(--settings-surface-muted);
    color: var(--color-app-text-secondary);
  }

  .settings-message {
    align-items: center;
    border-radius: var(--kv-radius-panel);
    display: flex;
    font-size: 13px;
    gap: 8px;
    line-height: 1.35;
    padding: 12px 14px;
  }

  .settings-message.success {
    background: var(--color-success-bg);
    color: var(--color-success-text);
  }

  .settings-message.error {
    background: var(--color-error-bg);
    color: var(--color-error-text);
  }

  .settings-loading,
  .settings-empty {
    align-items: center;
    background: var(--settings-surface);
    border: 1px dashed var(--settings-border);
    border-radius: var(--kv-radius-panel);
    color: var(--color-app-text-secondary);
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
    min-height: 160px;
    padding: 24px;
    text-align: center;
  }

  .settings-loading {
    border-style: solid;
    flex-direction: row;
    min-height: 104px;
  }

  .settings-empty h3 {
    color: var(--color-app-text);
    font-size: 15px;
    line-height: 1.25;
    margin: 0;
  }

  .settings-empty p {
    font-size: 13px;
    line-height: 1.4;
    margin: 0;
    max-width: 420px;
  }

  .settings-form-grid {
    display: grid;
    gap: 14px;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  }

  .settings-form-row {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
  }

  .settings-actions {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 16px;
  }

  .settings-table-shell {
    background: var(--settings-surface);
    border: 1px solid var(--settings-border);
    border-radius: var(--kv-radius-panel);
    box-shadow: var(--settings-shadow);
    overflow: auto;
  }

  sp-textfield,
  sp-picker,
  select.settings-native-select {
    width: 100%;
  }

  select.settings-native-select {
    background: var(--settings-control-bg);
    border: 1px solid var(--settings-control-border);
    border-radius: 6px;
    box-sizing: border-box;
    color: var(--color-app-text);
    font: inherit;
    min-height: 32px;
    padding: 0 10px;
  }

  select.settings-native-select:focus {
    border-color: var(--settings-accent);
    outline: 2px solid color-mix(in srgb, var(--settings-accent) 24%, transparent);
    outline-offset: 0;
  }

  select.settings-native-select:disabled {
    color: var(--color-app-text-secondary);
    cursor: not-allowed;
    opacity: 0.65;
  }

  sp-textfield {
    --mod-textfield-background-color: var(--settings-input-bg);
    --spectrum-textfield-background-color: var(--settings-input-bg);
    --mod-textfield-border-color: var(--settings-border);
    --mod-textfield-focus-indicator-color: var(--settings-accent);
  }

  sp-picker {
    --mod-picker-background-color-default: var(--settings-control-bg);
    --mod-picker-background-color-default-open: var(--settings-control-bg);
    --mod-picker-background-color-hover: var(--settings-control-hover);
    --mod-picker-background-color-hover-open: var(--settings-control-hover);
    --mod-picker-background-color-active: var(--settings-control-active);
    --mod-picker-background-color-key-focus: var(--settings-control-bg);
    --mod-picker-border-color-default: var(--settings-control-border);
    --mod-picker-border-default-open: var(--kv-accent-border);
    --mod-picker-border-color-default-open: var(--kv-accent-border);
    --mod-picker-border-color-hover: var(--kv-accent-border);
    --mod-picker-border-color-hover-open: var(--kv-accent-border);
    --mod-picker-border-active: var(--color-accent-border-strong);
    --mod-picker-border-color-active: var(--color-accent-border-strong);
    --mod-picker-border-color-key-focus: var(--settings-accent);
    --mod-picker-focus-indicator-color: var(--settings-accent);
    --mod-picker-font-color-default: var(--color-app-text);
    --mod-picker-font-color-default-open: var(--color-app-text);
    --mod-picker-font-color-hover: var(--color-app-text);
    --mod-picker-font-color-hover-open: var(--color-app-text);
    --mod-picker-font-color-active: var(--color-app-text);
    --mod-picker-font-color-key-focus: var(--color-app-text);
    --mod-picker-icon-color-default: var(--settings-accent);
    --mod-picker-icon-color-default-open: var(--settings-accent);
    --mod-picker-icon-color-hover: var(--settings-accent);
    --mod-picker-icon-color-hover-open: var(--settings-accent);
    --mod-picker-icon-color-active: var(--settings-accent);
    --mod-picker-icon-color-key-focus: var(--settings-accent);
  }

  sp-button[variant='secondary']:not(.settings-action-card):not(
      .settings-danger-button
    ) {
    --mod-button-background-color-default: var(--settings-control-bg);
    --mod-button-background-color-hover: var(--settings-control-hover);
    --mod-button-background-color-down: var(--settings-control-active);
    --mod-button-background-color-focus: var(--settings-control-bg);
    --mod-button-border-color-default: var(--settings-control-border);
    --mod-button-border-color-hover: var(--kv-accent-border);
    --mod-button-border-color-down: var(--color-accent-border-strong);
    --mod-button-border-color-focus: var(--settings-accent);
    --mod-button-content-color-default: var(--settings-accent);
    --mod-button-content-color-hover: var(--settings-accent);
    --mod-button-content-color-down: var(--settings-accent);
    --mod-button-content-color-focus: var(--settings-accent);
    --mod-button-focus-ring-color: var(--settings-accent);
  }

  sp-button.settings-danger-button {
    --mod-button-background-color-default: var(--settings-danger-bg);
    --mod-button-background-color-hover: var(--settings-danger-hover);
    --mod-button-background-color-down: var(--settings-danger-active);
    --mod-button-background-color-focus: var(--settings-danger-bg);
    --mod-button-border-color-default: var(--settings-danger-border);
    --mod-button-border-color-hover: color-mix(
      in srgb,
      var(--kv-danger-border) 70%,
      var(--kv-danger)
    );
    --mod-button-border-color-down: color-mix(
      in srgb,
      var(--kv-danger-border) 55%,
      var(--kv-danger)
    );
    --mod-button-border-color-focus: var(--settings-danger);
    --mod-button-content-color-default: var(--settings-danger);
    --mod-button-content-color-hover: var(--settings-danger);
    --mod-button-content-color-down: var(--settings-danger);
    --mod-button-content-color-focus: var(--settings-danger);
    --mod-button-focus-ring-color: var(--settings-danger);
  }

  sp-field-label {
    color: var(--color-app-text);
    font-size: 12px;
    font-weight: 650;
  }

  sp-help-text {
    color: var(--color-app-text-secondary);
    font-size: 11px;
  }

  .muted {
    color: var(--color-app-text-secondary);
  }

  @media (max-width: 760px) {
    .settings-card-grid,
    .settings-form-grid {
      grid-template-columns: 1fr;
    }

    .settings-panel,
    .settings-card {
      padding: 14px;
    }
  }
`;
